import { createHeader } from './components/Header.js';
import { createBottomNav } from './components/BottomNav.js';
import { openSearchModal } from './components/SearchModal.js';
import { renderHomeView } from './views/HomeView.js';
import { renderMovieDetailView } from './views/MovieDetailView.js';
import { renderPersonView } from './views/PersonView.js';
import { renderSongView } from './views/SongView.js';
import { renderLocationsView } from './views/LocationsView.js';
import { renderWatchlistView } from './views/WatchlistView.js';
import { renderAdminView } from './views/AdminView.js';
import { renderAccountView } from './views/AccountView.js';

export class Router {
  constructor(appElement) {
    this.app = appElement;
    window.addEventListener('hashchange', () => this.handleRoute());
  }

  init() {
    if (!window.location.hash) {
      window.location.hash = '#/';
    } else {
      this.handleRoute();
    }
  }

  async handleRoute() {
    const hash = window.location.hash || '#/';
    this.app.innerHTML = '';
    window.scrollTo(0, 0);

    const isDeepPage = hash !== '#/' && hash !== '';

    // Render Header
    const header = createHeader({
      showBack: isDeepPage,
      onBackClick: () => window.history.back(),
      onSearchClick: () => openSearchModal()
    });
    this.app.appendChild(header);

    // Route matching
    let viewElement = null;

    if (hash === '#/' || hash === '') {
      viewElement = await renderHomeView();
    } else if (hash.startsWith('#/movie/')) {
      const id = hash.replace('#/movie/', '');
      viewElement = await renderMovieDetailView(id);
    } else if (hash.startsWith('#/person/')) {
      const id = hash.replace('#/person/', '');
      viewElement = await renderPersonView(id);
    } else if (hash.startsWith('#/song/')) {
      const id = hash.replace('#/song/', '');
      viewElement = await renderSongView(id);
    } else if (hash === '#/songs') {
      viewElement = await renderSongView(null);
    } else if (hash.startsWith('#/location/')) {
      const id = hash.replace('#/location/', '');
      viewElement = await renderLocationsView(id);
    } else if (hash === '#/locations') {
      viewElement = await renderLocationsView(null);
    } else if (hash === '#/watchlist') {
      viewElement = await renderWatchlistView();
    } else if (hash === '#/account') {
      viewElement = renderAccountView();
    } else if (hash === '#/admin') {
      viewElement = renderAdminView();
    } else {
      viewElement = document.createElement('div');
      viewElement.className = 'main-content';
      viewElement.innerHTML = `
        <div style="text-align: center; padding: var(--space-2xl) 0;">
          <h2 style="font-size: 1.5rem; margin-bottom: 8px;">Page Not Found</h2>
          <p style="color: var(--text-secondary); margin-bottom: 16px;">The requested screen does not exist.</p>
          <a href="#/" class="btn-primary">Return Home</a>
        </div>
      `;
    }

    if (viewElement) {
      this.app.appendChild(viewElement);
    }

    // Render BottomNav for mobile
    const bottomNav = createBottomNav(hash);
    this.app.appendChild(bottomNav);
  }
}
